import { render } from "./PageListarAlimento.vue?vue&type=template&id=2879ecac"
import script from "./PageListarAlimento.vue?vue&type=script&lang=js"
export * from "./PageListarAlimento.vue?vue&type=script&lang=js"

import "./PageListarAlimento.vue?vue&type=style&index=0&id=2879ecac&lang=css"
/* custom blocks */
import block0 from "./PageListarAlimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__